import { Spin } from "antd";
// tslint:disable-next-line: no-submodule-imports
import "antd/dist/antd.css";
// tslint:disable-next-line: no-submodule-imports
import "antd/dist/antd.variable.min.css";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import "./App.css";
import "./i18n/config";
import LoginComponent from "./Pages/Authentication/Components/Login";
import SignupComponent from "./Pages/Authentication/Components/SignUp";
import HomePage from "./Pages/HomePage";
import LandingPage from "./Pages/LanguageSelectComponent";
import Redirection from "./Pages/Redirection";
import Response from "./Pages/Redirection/response";
import Root from "./Pages/Root";
import { Routes } from "./Utils/Constants/routes";
import interceptor from "./Utils/interceptor";

function App() {
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );

  const history = useHistory();
  const [t] = useTranslation();

  useState(() => {
    interceptor(history,t);
  });

  return (
    <Spin spinning={loading}>
      <Switch>
        <Route exact={true} path="/" component={LandingPage} />
        <Route exact={true} path={Routes.home} component={HomePage} />

        <Route exact={true} path={Routes.login} component={LoginComponent} />
        <Route exact={true} path={Routes.signup} component={SignupComponent} />
        <Route exact={true} path="/webview" component={Redirection} />
        <Route exact={true} path="/redirected" component={Response} />
        <Route exact={true} path="*" component={Root} />
      </Switch>
    </Spin>
  );
}
export default App;
